import React from 'react'
import 'moment/locale/zh-cn';
import {Path} from "../../../../public/path";
import {
    Button,
    Col,
    ConfigProvider,
    DatePicker,
    Input,
    Message,
    Modal,
    Row,
    Select,
    Table,
    Tooltip,
} from 'antd';
import Api from "../../../../public/api";
import DataItem from "../../../../cmpts/dataStats/DataItem";
import {Link} from "react-router-dom";
import SelectA from '../../../../cmpts/ant/Select'
import Util from "../../../../public/utils";
import {
    URL_MXD_GROUPBUY_STATS_NORMAL_GROUPLIST_EXPORT,
    URL_MXD_GROUPBUY_STATS_LADDAR_GROUPLIST_EXPORT
} from "../../../../public/variables";
import zh_CN from "antd/lib/locale-provider/zh_CN";
import TaskpostExplain from "../../../prizeunlock/activity_explain";
import ZkSearchGroup from "../../../../common/search/zkSearchGroup";
import ZkSelect from "../../../../common/search/zkSelect";
import ZkSplitBar from "../../../../common/split/zkSplitBar";
import ZkInput from "../../../../common/search/zkInput";
import ZkSelectDateRange from "../../../../common/search/zkSelectDateRange";
import ZkDateRange from "../../../../common/search/zkDateRange";
import ZkTable from "../../../../common/table/zkTable";
import ZkHeadText from "../../../../common/table/zkHeadText";
import ZkOptBtns from "../../../../common/table/zkOptBtns";
import Store from "../../../../store";

const {RangePicker} = DatePicker;
const Option = Select.Option;
const Column = Table.Column;
const DataKeys = {
    pendingOrder: 'pendingOrder', //	拼团中订单笔数
    successOrder: 'successOrder',//拼团成功订单笔数
    fakeSuccessOrder: 'fakeSuccessOrder', //虚拟成团订单笔数
    realSuccessOrder: 'realSuccessOrder', //实际成团订单笔数
    failOrder: 'failOrder',//拼团失败
};

const DataItemMetaData = {
    [DataKeys.pendingOrder]: {
        labelText: '拼团中',
        unitText: '笔',
        tooltip: '当前活动拼团中订单笔数',
        circleColor: "#F6BD15"
    },
    [DataKeys.successOrder]: {
        labelText: '拼团成功',
        unitText: '笔',
        tooltip: '当前活动拼团成功订单笔数',
        circleColor: "#6CC8EC"
    },
    [DataKeys.fakeSuccessOrder]: {
        labelText: '虚拟成团',
        unitText: '笔',
        tooltip: '当前活动虚拟用户成团订单笔数',
        circleColor: "#9270CA"
    },
    [DataKeys.realSuccessOrder]: {
        labelText: '实际成团',
        unitText: '笔',
        tooltip: '当前活动实际用户成团订单笔数',
        circleColor: "#FF9D4D"
    },
    [DataKeys.failOrder]: {
        labelText: '拼团失败',
        unitText: '笔',
        tooltip: '当前活动拼团失败订单笔数',
        circleColor: "#FF9D4D"
    },
}

let arr = 'ordinary_group_situation'
let arr1 = 'ordinary_group_situation1'
let currentPageNum=1

class IncomeRank extends React.Component {
    constructor(props) {
        super(props);
        this.changePage = this.changePage.bind(this);
        this.doSearch = this.doSearch.bind(this);
        this.getColums = this.getColums.bind(this);
        this.getGroupList = this.getGroupList.bind(this);
        this.state = {
            dataIndex: 0,// 默认显示的 板块数据
            activeTab: 0, // ladder的tab
            defaultData: [{
                pendingOrder: 0, //	拼团中订单笔数
                successOrder: 0,//拼团成功订单笔数
                fakeSuccessOrder: 0, //虚拟成团订单笔数
                realSuccessOrder: 0, //实际成团订单笔数
                failOrder: 0,//拼团失败
            }],
            statDataInfo: [{
                pendingOrder: 0, //	拼团中订单笔数
                successOrder: 0,//拼团成功订单笔数
                fakeSuccessOrder: 0, //虚拟成团订单笔数
                realSuccessOrder: 0, //实际成团订单笔数
                failOrder: 0,//拼团失败
            }],
            bodyData: {
                groupbuyId: Util.getActivityId() == 0 ? -1 : Util.getActivityId(), // 全部活动
                nickName: '',
                groupStatus: 9,
                startTime: '',
                endTime: '',
            },
            exportData: {
                groupbuyId: Util.getActivityId() == 0 ? -1 : Util.getActivityId(),
                groupStatus: 9,
                startTime: '',
                endTime: ''
            },
            pageInfo: {
                pageSize: 10,
                pageNum: 1,
                pages: 1,
                total: 1,
            },
            list: [], //    筛选字段
            taskList: [],
            channelList: [
                {
                    channelId: 0,
                    channelName: '全部渠道'
                }
            ], //渠道下拉列表
            taskId: null,
            userVisible: false, //用户关系详情的modal
            userQuery: {  //用户关系详情的queryParams
                pageSize: 5,
                pageNum: 1
            },
            customerId: '',//用户的id table
            upLevel: {},
            detail: [], //用户关系详情的table值
            dateStr: [],
            dateArr: []
        };
        this.groupStatusList = [
            {
                name: '全部',
                groupStatus: 9,
            }, {
                name: '拼团中',
                groupStatus: 0,
            }, {
                name: '拼团成功',
                groupStatus: 1,
            }, {
                name: '拼团失败',
                groupStatus: 2,
            }
        ];
    }

    // componentWillMount() {
    //     let str = Store.getQueryParams(arr)
    //     let str1 = Store.getQueryParams(arr1)
    //     if(this.props.groupBooktype == 'common'){
    //         if(str && str.params){
    //             this.setState({
    //                 bodyData:str.params
    //             })
    //         }
    //         if(str && str.pageNum){
    //             currentPageNum = str.pageNum
    //         }
    //     }else if(this.props.groupBooktype == 'isCommon'){
    //         if(str1 && str1.params){
    //             this.setState({
    //                 bodyData:str1.params
    //             })
    //         }
    //         if(str1 && str1.pageNum){
    //             currentPageNum = str1.pageNum
    //         }
    //     }
    //
    // }

    componentDidMount() {
        this.initActivityList();
        this.getGroupData(-1);
    }

    componentWillReceiveProps(nextProps, nextContext) {

    }

    getGroupData(id) { // 数据展示板
        let groupbuyId = id ? id : this.state.bodyData.groupbuyId;
        if (this.props.type == 'ladder') {
            Api.getGroupBuyLadderGroupData(groupbuyId, (data) => {
                if (data.list.length == 0) {
                    this.transStatData(this.state.defaultData); // 初始数据
                } else {
                    this.transStatData(data.list);
                }
            })
        } else {
            Api.getGroupBuyGroupData(groupbuyId, (data) => {
                if (data.list.length == 0) {
                    this.transStatData(this.state.defaultData); // 初始数据
                } else {
                    this.transStatData(data.list);
                }
            })
        }

    }

    getGroupList(params, pageNum, pageSize) {
        currentPageNum = pageNum
        // if(this.props.groupBooktype == 'common'){
        //     Store.setAddFriendQueryParams(arr,this.state.bodyData,currentPageNum)
        // }else if(this.props.groupBooktype == 'isCommon'){
        //     Store.setAddFriendQueryParams(arr1,this.state.bodyData,currentPageNum)
        // }
        let queryParams = {
            pageSize: pageSize,
            pageNum: pageNum,
        };
        return new Promise((resolve) => {
            if (this.props.type == 'ladder') {
                Api.getGroupBuyLadderGroupList(queryParams, params, (data) => {
                    let list = data.list;
                    list.map((item, index) => {
                        if (item.endTime > new Date().getTime()) {
                            this.showTimeData(item, index)
                        }
                    });
                    resolve(data)
                })
            } else {
                Api.getGroupBuyGroupList(queryParams, params, (data) => {
                    let list = data.list;
                    list.map((item, index) => {
                        if (item.endTime > new Date().getTime()) {
                            this.showTimeData(item, index)
                        }
                    });
                    resolve(data)
                })
            }
        });
    }

    transStatData(data) {
        // let totalData = data; // 数组格式[{}]
        let statDataInfo = [];
        data.map((item, i) => {
            let dataInfo = {};
            for (let dataKey in DataKeys) {
                if (DataItemMetaData[dataKey]) {
                    dataInfo[this.getDataItemName(dataKey)] = {
                        labelText: DataItemMetaData[dataKey].labelText,
                        ydLabelText: '昨日' + DataItemMetaData[dataKey].labelText,
                        value: item[dataKey],
                        unitText: DataItemMetaData[dataKey].unitText,
                        showYD: false,
                        tooltip: DataItemMetaData[dataKey].tooltip,
                        circleColor: DataItemMetaData[dataKey].circleColor,
                    };
                }
            }
            statDataInfo.push(dataInfo)
        });
        this.setState({
            statDataInfo: statDataInfo
        });
    }

    initActivityList() {
        Api.getGroupBuyActList(this.props.type, (data) => {
            let arr = data.list;
            arr.unshift({
                groupbuyId: -1,
                groupbuyName: '全部活动',
            });
            this.setVal('taskList', arr);
        })


    }

    doSearch() {
    }

    reset() {
        let bodyData = {
            groupbuyId: -1, // 全部活动
            nickName: '',
            groupStatus: 9,
            startTime: '',
            endTime: '',
        };
        this.setVal('bodyData', bodyData);
    }

    getExportId(key, val) {
        let exportData = this.state.exportData;
        exportData[key] = val;
        this.setVal('exportData', exportData);
    }

    getDataItemName(key) {
        return key + 'DataItem';
    }

    changePage(pageNum, pageSize) {
        let pageInfo = this.state.pageInfo;
        pageInfo.pageNum = pageNum;
        pageInfo.pageSize = pageSize;
        this.setVal('pageInfo', pageInfo)
    }

    setVal(key, val) {
        this.setState({
            [key]: val
        })
    }

    changeInputBodyData(key, e) {
        let bodyData = this.state.bodyData;
        bodyData[key] = e.target.value;
        this.setVal('bodyData', bodyData);
    }

    taskStatusChange(name, val) {
        let bodyData = this.state.bodyData;
        bodyData[name] = val;
        this.setVal('bodyData', bodyData);
    }

    hideModal(key) {
        this.setVal([key], false);
    }

    changePageGroup(pageNum, pageSize) {
        console.log('pageNum', pageNum, 'pageSize', pageSize)
        let userQuery = this.state.userQuery;
        userQuery.pageNum = pageNum;
        userQuery.pageSize = 5;
        this.setVal('userQuery', userQuery)
        this.getUserDetail(this.state.currentGroupID);
    }

    getUserDetail(id) {
        this.setState({
            currentGroupID: id
        })
        this.setVal('userVisible', true);
        let userQuery = this.state.userQuery;
        let arr = [];
        arr.push('?pageNum=' + userQuery.pageNum);
        arr.push('pageSize=' + userQuery.pageSize);
        let str = arr.join('&');
        Api.getGroupBuyGroupDetail(str, id, (data) => {
            console.log(' data.pagInfo', data.pagInfo)
            this.setState({
                // pagInfoDetail: data.pagInfo ,
                detail: data.list,
                userQuery: data.pagInfo
            })

            console.log('userQuery', this.state.userQuery)

        })
    }

    showModal(key) {
        this.setVal([key], true)
    }

    exportDataInfo() {
        let arr = [];
        arr.push('groupbuyId=' + this.state.exportData.groupbuyId);
        arr.push('groupStatus=' + this.state.exportData.groupStatus);
        arr.push('startTime=' + this.state.exportData.startTime);
        arr.push('endTime=' + this.state.exportData.endTime);
        let str = arr.join('&');
        if (this.props.type == 'ladder') {
            Util.downLoadFile(URL_MXD_GROUPBUY_STATS_LADDAR_GROUPLIST_EXPORT + '?' + str);
        } else {
            Util.downLoadFile(URL_MXD_GROUPBUY_STATS_NORMAL_GROUPLIST_EXPORT + '?' + str);
        }
    }

    changeTab(tab) {
        // if (this.state.)
        this.setVal('dataIndex', tab);
        this.setVal('activeTab', tab);
    }

    timeChange(val) {
        if (val && val.length == 2) {
            let begin = val[0].valueOf();
            let end = val[1].valueOf();
            let bodyData = this.state.bodyData;
            bodyData.startTime = begin;
            bodyData.endTime = end;
            this.setVal('bodyData', bodyData);
        }
    }

    getExportTimeChange(val) {
        if (val && val.length == 2) {
            let begin = val[0].valueOf();
            let end = val[1].valueOf();
            let exportData = this.state.exportData;
            exportData.startTime = begin;
            exportData.endTime = end;
            this.setVal('exportData', exportData);
        }
    }

    addZero(num) {
        if (num < 10) {
            num = "0" + num
        }
        return num
    }

    showTimeData(data, index, num) {
        let dateStrObj = this.state.dateStr,
            dateArr = this.state.dateArr,
            groupId = data.groupId;
        let remainTime = data.remainTime;
        this.timerPrice = setInterval(() => {
            let dateDate = remainTime / 1000;
            if (dateDate < 1) {
                clearInterval(this.timerPrice)
            } else {
                let dateStr = "";
                if (parseInt(dateDate / 86400) > 0) {
                    dateStr += parseInt(dateDate / 86400) + "天 "
                    dateDate = dateDate % 86400
                }

                if (dateDate / 3600 >= 0) {
                    dateStr += this.addZero(parseInt(dateDate / 3600)) + ":"
                    dateDate = dateDate % 3600
                }
                if (dateDate / 60 >= 0 && parseInt(dateDate / 3600) <= 0) {
                    dateStr += this.addZero(parseInt(dateDate / 60)) + ":"
                    dateStr += this.addZero(parseInt(dateDate % 60))
                }
                if (dateStr && dateArr.indexOf(index) < 0) {
                    dateArr.push(index)
                }
                if (groupId) {
                    dateStrObj[groupId] = dateStr
                }
                this.setState({
                    dateStr: dateStrObj,
                    dateArr: dateArr
                })
            }
            remainTime = remainTime - 1000;
        }, 1000)
    }

    isLadder() {
        if (this.props.type == 'ladder') {
            return true;
        }
        return false;
    }

    activityChange(params) {
        let groupbuyId = params.groupbuyId;
        let bodyData = this.state.bodyData;
        bodyData.groupbuyId = groupbuyId;
        this.setVal('bodyData', bodyData);
        this.getGroupData(groupbuyId);
    }

    query(type,params) {
        if(type == 'reset'){
            params.groupStatus = 9
        }
        let bodyData = this.state.bodyData;
        bodyData.nickName = params.nickName;
        bodyData.groupStatus = params.groupStatus;
        if (params.groupDate.length == 2) {
            bodyData.startTime = params.groupDate[0];
            bodyData.endTime = params.groupDate[1];
        } else {
            bodyData.startTime = '';
            bodyData.endTime = '';
        }
        this.setState({
            bodyData: bodyData
        },()=>{
            // if(this.props.groupBooktype == 'common'){
            //     Store.setAddFriendQueryParams(arr,this.state.bodyData,currentPageNum)
            // }else if(this.props.groupBooktype == 'isCommon'){
            //     Store.setAddFriendQueryParams(arr1,this.state.bodyData,currentPageNum)
            // }
        })
    }

    getColums() {
        return [
            {
                dataIndex: 'groupbuyName',
                title: '活动信息',
                width: '230px',
                render: (text, record) => (
                    <ZkHeadText headUrl={record.coverImgUrl} headText={text}/>
                )
            },
            {
                dataIndex: 'groupBuyNum',
                title: () => {
                    return (
                        <div className={'goodsStock'}>
                            <span className={'text'}>参团数据</span>
                            <Tooltip className={'retailTootip'}
                                     title={TaskpostExplain.InGroupData()}>
                                <i className="icon-question"></i>
                            </Tooltip>
                        </div>
                    )
                },
                render: (val, record) => (
                    <span className='mxd-cursor-pointer'>{record.memberNum + '/' + record.groupBuyNum}</span>
                )
            },
            {
                dataIndex: 'nickname',
                title: '团长',
                width:'170px',
                render: (text, record) => (
                    <ZkHeadText headText={text} headUrl={record.headImgUrl} circular={true}/>
                )
            },
            {
                dataIndex: 'groupTime',
                title: '开团时间',
                width:'200px',
                render: (text, record, index) => (
                    <span>{new Date(record.groupTime).format('yyyy-MM-dd hh:mm')}</span>
                )
            },
            {
                dataIndex: 'endTime',
                title: '组团剩余时间',
                width:'200px',
                render: (text, record, index) => (
                    <span>
                        {this.state.dateStr[record.groupId] && record.status == 0 ? this.state.dateStr[record.groupId] : "-"}
                    </span>
                )
            },
            {
                dataIndex: 'status',
                title: '拼团状态',
                render: (status, record, index) => (
                    <div>
                        <span className={'text-pending'}>{status == 0 ? '拼团中' : ''}</span>
                        <span className={'text-success'}>{status == 1 ? '拼团成功' : ''}</span>
                        <span className={'text-fail'}>{status == 2 ? '拼团失败' : ''}</span>
                    </div>
                )
            },
            {
                dataIndex: 'key',
                title: '操作',
                align: 'center',
                render: (text, record, index) => (
                    <ZkOptBtns>
                        <span className={'text-primary'} onClick={this.getUserDetail.bind(this, record.groupId)}>
                            团员情况
                        </span>
                    </ZkOptBtns>
                )
            },
        ];
    }

    render() {
        return (
            <>
                <div className='searchPanel flexSpaceBetween'>
                    <ZkSearchGroup key={'activitySearch'}
                                   onChange={this.activityChange.bind(this)}
                                   btnBlock={false} linkage={true} hideBtns={true}>
                        <ZkSelect title={'活动名称：'} valueKey='groupbuyId'
                                  value={this.state.bodyData.groupbuyId} defaultValue={-1}>
                            {
                                this.state.taskList.map((item, key) => {
                                    return <Option key={key} value={item.groupbuyId}>{item.groupbuyName}</Option>
                                })
                            }
                        </ZkSelect>
                    </ZkSearchGroup>
                    {
                        this.props.type == 'ladder' ? <div className={'ladder-tab'}>
                            <span className={this.state.activeTab == 0 ? 'active-tab' : ''}
                                  onClick={this.changeTab.bind(this, 0)}>全部</span>
                            <span className={this.state.activeTab == 1 ? 'active-tab' : ''}
                                  onClick={this.changeTab.bind(this, 1)}>第一阶梯</span>
                            <span className={this.state.activeTab == 2 ? 'active-tab' : ''}
                                  onClick={this.changeTab.bind(this, 2)}>第二阶梯</span>
                            <span className={this.state.activeTab == 3 ? 'active-tab' : ''}
                                  onClick={this.changeTab.bind(this, 3)}>第三阶梯</span>
                        </div> : ''
                    }
                </div>
                <div>
                    <div className={this.props.type == 'ladder' ? 'data-panel-group' : 'data-panel-group-normal'}>
                        {
                            this.state.statDataInfo ?
                                <ul className={'mxd-col-5'}>
                                    <li className='dataItemWraper'>
                                        <DataItem
                                            data={this.state.statDataInfo[this.state.dataIndex][this.getDataItemName(DataKeys.pendingOrder)]}/>
                                    </li>
                                    <li className='dataItemWraper'>
                                        <DataItem
                                            data={this.state.statDataInfo[this.state.dataIndex][this.getDataItemName(DataKeys.successOrder)]}/>
                                    </li>
                                    <li className='dataItemWraper'>
                                        <DataItem
                                            data={this.state.statDataInfo[this.state.dataIndex][this.getDataItemName(DataKeys.realSuccessOrder)]}/>
                                    </li>
                                    <li className='dataItemWraper'>
                                        <DataItem
                                            data={this.state.statDataInfo[this.state.dataIndex][this.getDataItemName(DataKeys.fakeSuccessOrder)]}/>
                                    </li>
                                    <li className='dataItemWraper'>
                                        <DataItem
                                            data={this.state.statDataInfo[this.state.dataIndex][this.getDataItemName(DataKeys.failOrder)]}/>
                                    </li>
                                </ul> : ''
                        }
                    </div>
                </div>
                <ZkSplitBar/>
                <ZkSearchGroup ref={r => this.groupMemberSearchGroup = r}
                               onOk={this.query.bind(this,'ok')}
                               onReset={this.query.bind(this,'reset')}
                               btnBlock={false}
                               otherBtns={<Button onClick={this.showModal.bind(this, 'exportVisible')}>导出</Button>}>
                    <ZkInput title={'购买用户：'} defaultValue={this.state.bodyData.nickName} valueKey='nickName' placeholder={'请输入用户昵称'}></ZkInput>
                    <ZkSelect title={'拼团状态：'} valueKey='groupStatus'
                              defaultValue={this.state.bodyData.groupStatus}>
                        {
                            this.groupStatusList.map((item, key) => {
                                return <Option key={key} value={item.groupStatus}>{item.name}</Option>
                            })
                        }
                    </ZkSelect>
                    <ZkDateRange title={'开团时间：'} valueKey={'groupDate'} defaultValue={[this.state.bodyData.startTime,this.state.bodyData.endTime]}/>
                </ZkSearchGroup>
                <ZkTable owncolumns={this.getColums.bind(this)}
                         queryAction={this.getGroupList}
                         currentPageNum={currentPageNum}
                         params={this.state.bodyData} baseProps={{scroll: {x: 1000}}}/>

                <Modal title={'全部团员'}
                       visible={this.state.userVisible}
                       wrapClassName={'retailRankModal tableLayoutFixed'}
                       onCancel={this.hideModal.bind(this, 'userVisible')}
                       onOk={this.hideModal.bind(this, 'userVisible')}
                >
                    <div className={'qy-table'}>
                        <Table dataSource={this.state.detail}
                               pagination={{
                                   hideOnSinglePage: true,
                                   showQuickJumper: true,
                                   total: this.state.userQuery ? this.state.userQuery.total : 1,
                                   current: this.state.userQuery ? this.state.userQuery.pageNum : 1,
                                   defaultPageSize: this.state.userQuery ? this.state.userQuery.pageSize : 5,
                                   onChange: this.changePageGroup.bind(this),
                               }}
                        >
                            <Column title={'团员信息'}
                                    dataIndex={'key'}
                                    render={(text, record, index) => (
                                        <div>
                                             <span className={'qyheadImgInfo'}>
                                                <div className={'images'}
                                                     style={{backgroundImage: 'url(' + record.headImgUrl + ')'}}>
                                                </div>
                                                 <div>
                                                     <span>{record.nickname}</span><br/>
                                                     <span className={record.memberType == 0 ? 'group-cap' : ''}>
                                                         {record.memberType == 0 ? '团长' : ''}
                                                         {record.memberType == 2 ? '虚拟团员' : ''}
                                                     </span>
                                                 </div>
                                            </span>
                                        </div>
                                    )}
                            />
                            <Column
                                title={'参团时间'}
                                width={200}
                                dataIndex={'key'}
                                render={(text, record, index) => (
                                    <span>
                                        {new Date(record.joinTime).format('yyyy-MM-dd hh:mm:ss')}
                                    </span>
                                )}
                            />
                            <Column
                                title={'动作'}
                                dataIndex={'key'}
                                render={(text, record, index) => (
                                    <span
                                        className={record.memberType == 0 ? 'manage-group' : ''}>{record.memberType == 0 ? '开团' : '参团'}</span>
                                )}
                            />
                            <Column
                                title={'操作'}
                                dataIndex={'key'}
                                render={(text, record, index) => (
                                    <div>
                                        {
                                            record.memberType == 2 ? '-' : <Link target='_blank'
                                                                                 to={Path.goGroupBuyOrderDetail() + record.orderId}>
                                                订单详情
                                            </Link>
                                        }
                                    </div>

                                )}
                            />
                        </Table>
                    </div>
                </Modal>
                {/*导出*/}
                <Modal
                    title="导出"
                    visible={this.state.exportVisible}
                    onOk={this.exportDataInfo.bind(this)}
                    okText={'导出'}
                    onCancel={this.hideModal.bind(this, 'exportVisible')}
                >
                    {
                        this.state.exportVisible ?
                            <div className={'send-row'}>
                                <Row>
                                    <Col span={4}>
                                        <span className='span-line'>活动信息：</span>
                                    </Col>
                                    <Col span={20}>
                                        <SelectA
                                            height={36}
                                            style={{width: '100%'}}
                                            optionList={this.state.taskList}
                                            placeholder='全部活动'
                                            value={this.state.exportData.groupbuyId == -1 ? '全部活动' : this.state.exportData.groupbuyId}
                                            valueKey={'groupbuyId'}
                                            selected={this.getExportId.bind(this, 'groupbuyId')}
                                            optionKey={'groupbuyName'}
                                        ></SelectA>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={4}>
                                        <span className='span-line'>拼团状态：</span>
                                    </Col>
                                    <Col span={20}>
                                        <SelectA
                                            style={{width: '100%'}}
                                            optionList={this.groupStatusList}
                                            placeholder='全部状态'
                                            value={this.state.exportData.groupStatus == 9 ? '全部' : this.state.exportData.groupStatus}
                                            valueKey={'groupStatus'}
                                            selected={this.getExportId.bind(this, 'groupStatus')}
                                            optionKey={'name'}
                                        ></SelectA>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={4}>
                                        <span className='span-line'>开团时间：</span>
                                    </Col>
                                    <Col span={20}>
                                        <ConfigProvider locale={zh_CN}>
                                            <RangePicker onChange={this.getExportTimeChange.bind(this)}
                                                         style={{width: '100%'}}
                                                         defaultValue={this.state.exportData.startTime > 0 ? [new moment(this.state.exportData.startTime), new moment(this.state.exportData.endTime)] : [null, null]}
                                                         showTime
                                                         separator="至"/>
                                        </ConfigProvider>
                                    </Col>
                                </Row>
                            </div> : ''
                    }
                </Modal>

            </>
        );
    }


}

export default IncomeRank